import $ from 'jquery';
import appAjax from '../helpers/ajax';
import appUi from '../helpers/ui';

function ModalOpenVault({onSaved, onCreated}) {
    const onSubmit = (e) => {
        e.preventDefault();

        var elForm = e.target;
        var formData = $(elForm).serialize();
        var elModal = $(elForm).closest('.modal');
        var vaultUuid = $(elModal).data('uuid');
        var url = appAjax.utilBaseUrl + '/?p=api&act=open_vault&uuid=' + vaultUuid;

        appAjax._ajax_send(formData, {
            beforeSend: function() {
                $(elForm).find('button, input[type=text], input[type=password]').attr('disabled', 'disabled');
            },
            success: function(response) {
                $(elForm).hide();

                var decodedContent = response.data.content;
                if (response.data.encoding == 'base64') {
                    decodedContent = appAjax.b64_to_utf8(decodedContent);
                }

                var elModalEditVault = $(elModal).find('form#web_modal_form_editvault');
                $(elModalEditVault).find('input[name=title]').val(response.data.title);
                $(elModalEditVault).find('input[name=update_token]').val(response.data.update_token);
                $(elModalEditVault).find('textarea[name=content]').val(decodedContent).focus();
                $(elModalEditVault).show();
            },
            error: function(response) {
                appUi.uiAlert(response.message, null, 'Failed', 'error');
            },
            always: function() {
                $(elForm).find('button, input[type=text], input[type=password]').removeAttr('disabled');

                //-- Clear passphrase
                $(elForm).find('input[name=passphrase]').val('');
            }
        }, 'Authenticating...', url);

        return false;
    };

    const onSubmitEditVault = (e) => {
        e.preventDefault();

        var rawContent = $(e.target).find('textarea[name=content]').val();
        var encodedContent = appAjax.utf8_to_b64(rawContent);

        var elForm = e.target;
        var formData = {
            title: $(elForm).find('input[name=title]').val(),
            content: encodedContent,
            update_token: $(elForm).find('input[name=update_token]').val(),
            lat: $(elForm).find('input[name=lat]').val(),
            lng: $(elForm).find('input[name=lng]').val(),
            encoding: 'base64'
        };

        var elModal = $(elForm).closest('.modal');
        var vaultUuid = $(elModal).data('uuid');
        var url = appAjax.utilBaseUrl + '/?p=api';

        var isCreate = false;

        if (vaultUuid == '@new') {
            isCreate = true;
            url += '&act=create_vault';
        } else {
            url += '&act=store_vault&uuid=' + vaultUuid;
        }

        appAjax._ajax_send(formData, {
            beforeSend: function() {
                $(elForm).find('button, input[type=text], input[type=password], textarea').attr('disabled', 'disabled');
            },
            success: function(response) {
                if (isCreate) {
                    $(elModal).modal('hide');
                    if (typeof onCreated === 'function') {
                        onCreated(response.data);
                    }
                } else {
                    if (typeof onSaved === 'function') {
                        onSaved(response.data);
                    }
                }

                appUi.uiToast(response.message, 'success', function() {
                    
                });
            },
            error: function(response) {
                appUi.uiAlert(response.message, null, 'Failed', 'error');
            },
            always: function() {
                $(elForm).find('button, input[type=text], input[type=password], textarea').removeAttr('disabled');
            }
        }, 'Saving...', url);

        return false;
    };

  return (
    <div
        className="modal"
        style={{ display: "none" }}
        tabIndex={-1}
        id="web_modal_unlockvault"
        data-backdrop="static" data-keyboard="false"
        >
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
            <div className="modal-header bg-secondary text-white">
                <h5 className="modal-title">Unlock Vault</h5>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
           
            
            <div className="modal-body">
                <form action="#" method="POST" id="web_modal_form_unlockvault" onSubmit={onSubmit}>
                    <div className="form-group row">
                        <label className="col-sm-3"><b>Vault</b></label>
                        <div className="col-sm-9">
                            <span className="vault_title"></span>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="web_modal_txtpsphrs" className="col-sm-3 col-form-label">
                            Passphrase
                        </label>
                        <div className="col-sm-9">
                            <input
                                type="password"
                                className="form-control form-control-sm"
                                id="web_modal_txtpsphrs"
                                required
                                name="passphrase"
                                placeholder="Passphrase"
                                autoComplete='off'
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-sm-9 offset-sm-3">
                            <button type="submit" className="btn btn-primary btn-sm">
                                <i className="fa fa-lock" /> Unlock
                            </button>
                        </div>
                    </div>

                    <input type="hidden" name="encoding" value="base64" />
                    <input type="hidden" name="lat" value="" className="val_pos_lat" />
                    <input type="hidden" name="lng" value="" className="val_pos_lng" />
                </form>
                <form action="#" method="POST" id="web_modal_form_editvault" onSubmit={onSubmitEditVault} style={{ display: "none" }}>
                    <input name="title" type="text" className="form-control form-control-sm mb-3" placeholder="Vault Title" autoComplete='off' required />
                    <textarea name="content" className="form-control form-control-sm" placeholder="Content" autoComplete='off' required
                        autoCorrect="off" autoCapitalize="off" spellCheck="false"
                        style={{minHeight: '400px', fontFamily: 'monospace', fontSize: '11pt'}}></textarea>
                    <input name="update_token" type="hidden" value="" />

                    <div className="mt-3">
                        <button type="submit" className="btn btn-primary btn-sm">
                            <i className="fa fa-save" /> Save
                        </button>
                    </div>

                    <input type="hidden" name="lat" value="" className="val_pos_lat" />
                    <input type="hidden" name="lng" value="" className="val_pos_lng" />
                </form>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                >
                    Close
                </button>
            </div>
            </div>
        </div>
        </div>

    );
}

export function initModalOpenVault(dom, vaultData) {

    $(dom).off('shown.bs.modal').on('shown.bs.modal', function (e) {
        $(this).find('input:visible, textarea:visible').first().focus();
    });

    if (appAjax.currentGeoLocation) {
        $(dom).find('input[name=lat]').val(appAjax.currentGeoLocation.lat);
        $(dom).find('input[name=lng]').val(appAjax.currentGeoLocation.lng);
    }

    $(dom).find('input[name=passphrase]').val('');
    $(dom).find('input[name=update_token]').val('');
    $(dom).find('input[name=title]').val('');
    $(dom).find('textarea[name=content]').val('');

    if (vaultData) {
        $(dom).find('.modal-title').text('Unlock Vault');

        $(dom).find('.vault_title').text(vaultData.title);
        $(dom).data('uuid', vaultData.uuid);
    
        $(dom).find('form#web_modal_form_unlockvault').show();
        $(dom).find('form#web_modal_form_editvault').hide();

    } else {
        $(dom).find('.modal-title').text('Create Vault');

        $(dom).find('.vault_title').text('');
        $(dom).data('uuid', '@new');
    
        $(dom).find('form#web_modal_form_unlockvault').hide();
        $(dom).find('form#web_modal_form_editvault').show();

        //-- Clear form
        $(dom).find('form#web_modal_form_editvault').find('input[name=title]').val('');
        $(dom).find('form#web_modal_form_editvault').find('input[name=update_token]').val('');
        $(dom).find('form#web_modal_form_editvault').find('textarea[name=content]').val('');
    }
    
};

export default ModalOpenVault;
